/**
 * Defines color scheme for using with surface items
 */
export interface ColorScheme {
    /**
     * The css color for accessible text on a calPrimary background
     * DEPRECATED, will be removed in future version. Use accessibleText.calPrimaryBackground instead
     */
    text: string;

    /**
     * The css color for accessible text on a calLighter background
     * DEPRECATED, will be removed in future version. Use accessibleText.calLighterBackground instead
     */
    textAlt: string;

    calDarker: string;
    calDark: string;
    calDarkAlt: string;
    calPrimary: string;
    calSecondary: string;
    calTertiary: string;
    calLight: string;
    calLighter: string;
    calLighterAlt: string;
    colorName: () => string;

    /**
     * The css color for accessible test on the given backgrounds
     */
    accessibleText?: AccessbileTextScheme;
}

export interface AccessbileTextScheme {
    calPrimaryBackground: string;
    calLighterBackground: string;
    msColorWhiteBackground: string;
    msColorNeutralLighterBackground: string;
}

export default ColorScheme;

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties with the calPrimary scheme color.
 */
export function colorSchemeToCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calPrimary,
        color: scheme.accessibleText ? scheme.accessibleText.calPrimaryBackground : scheme.text,
    };
}

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties for the calendar surface with the calLight scheme color.
 */
export function colorSchemeToDarkCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calDarkAlt,
        color: scheme.accessibleText ? scheme.accessibleText.calPrimaryBackground : scheme.text,
    };
}

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties for the calendar surface with the calLight scheme color.
 */
export function colorSchemeToInvertCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calLighter,
        color: scheme.accessibleText ? scheme.accessibleText.calLighterBackground : scheme.textAlt,
    };
}

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties for the calendar surface with the calLight scheme color.
 */
export function colorSchemeToMediumCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calLight,
        color: scheme.accessibleText ? scheme.accessibleText.calPrimaryBackground : scheme.text,
    };
}

/**
 * Function to convert ColorScheme into color and backgroundColor CSS properties for the calendar surface with the calLight scheme color.
 */
export function colorSchemeToLightCss(scheme: ColorScheme): React.CSSProperties {
    return {
        backgroundColor: scheme.calLighter,
        color: scheme.accessibleText ? scheme.accessibleText.calPrimaryBackground : scheme.text,
    };
}
